import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"]
  static values = { startsAt: String }

  connect() {
    this.targetDate = new Date(this.startsAtValue)
    this.updateCountdown()
    this.timer = setInterval(() => this.updateCountdown(), 1000)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  updateCountdown() {
    const now = new Date()
    const diff = this.targetDate - now

    if (diff <= 0) {
      // Countdown finished, reload page to show live dashboard
      clearInterval(this.timer)
      window.location.reload()
      return
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    this.daysTarget.textContent = this.padNumber(days)
    this.hoursTarget.textContent = this.padNumber(hours)
    this.minutesTarget.textContent = this.padNumber(minutes)
    this.secondsTarget.textContent = this.padNumber(seconds)
  }

  padNumber(num) {
    return num.toString().padStart(2, '0')
  }
}
